import React from 'react';
import './NetOverlay.css';

/**
 * NetOverlay Component
 * SVG animated net overlay for units affected by net/immobilize effects
 * Covers the entire unit with a rope net pattern
 */
function NetOverlay() {
  return (
    <div className="net-overlay">
      <svg
        className="net-svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          {/* Rope texture gradient */}
          <linearGradient id="ropeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#8B7355" />
            <stop offset="50%" stopColor="#A0896C" />
            <stop offset="100%" stopColor="#8B7355" />
          </linearGradient>

          {/* Drop shadow for depth */}
          <filter id="netShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="1" dy="1" stdDeviation="1" floodColor="#000" floodOpacity="0.4" />
          </filter>
        </defs>

        {/* Diagonal lines (top-left to bottom-right) */}
        <g className="net-lines-group net-lines-diagonal-1">
          <line x1="0" y1="0" x2="100" y2="100" />
          <line x1="25" y1="0" x2="100" y2="75" />
          <line x1="50" y1="0" x2="100" y2="50" />
          <line x1="75" y1="0" x2="100" y2="25" />
          <line x1="0" y1="25" x2="75" y2="100" />
          <line x1="0" y1="50" x2="50" y2="100" />
          <line x1="0" y1="75" x2="25" y2="100" />
        </g>

        {/* Diagonal lines (top-right to bottom-left) */}
        <g className="net-lines-group net-lines-diagonal-2">
          <line x1="100" y1="0" x2="0" y2="100" />
          <line x1="75" y1="0" x2="0" y2="75" />
          <line x1="50" y1="0" x2="0" y2="50" />
          <line x1="25" y1="0" x2="0" y2="25" />
          <line x1="100" y1="25" x2="25" y2="100" />
          <line x1="100" y1="50" x2="50" y2="100" />
          <line x1="100" y1="75" x2="75" y2="100" />
        </g>

        {/* Knots at intersections */}
        <g className="net-knots">
          <circle cx="50" cy="50" r="3" />
          <circle cx="25" cy="25" r="2.5" />
          <circle cx="75" cy="25" r="2.5" />
          <circle cx="25" cy="75" r="2.5" />
          <circle cx="75" cy="75" r="2.5" />
          <circle cx="50" cy="25" r="2" />
          <circle cx="50" cy="75" r="2" />
          <circle cx="25" cy="50" r="2" />
          <circle cx="75" cy="50" r="2" />
        </g>
      </svg>
    </div>
  );
}

export default NetOverlay;
